import { CommonFunctions } from "../static/common-functions";

export class DQOIState
{
    customerId: any;
    locationId: any;
    dispatchId: any;
    quoteId: any;
    invoiceId: any;
    orderId: any;
    get hasDispatchId(): boolean {
        return CommonFunctions.hasValue(this.dispatchId);
    }
    get hasQuoteId(): boolean {
        return CommonFunctions.hasValue(this.quoteId);
    }
    get hasOrderId(): boolean {
        return CommonFunctions.hasValue(this.orderId);
    }
    get hasInvoiceId(): boolean {
        return CommonFunctions.hasValue(this.invoiceId);
    }
}
